import React from "react";
import { GlobalProvider } from "../common/GlobalContext";
import ListingCard from "./ListingCard";

const InfoWindow = (props) => {
  return (
    <GlobalProvider
      compliance={props.compliance}
      favorites={props.favorites}
      siteUser={props.siteUser}
      theme={props.theme}
      CDN_IMAGE_SERVER_URL={props.CDN_IMAGE_SERVER_URL}
      RECAPTCHA_CLIENT={props.RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={props.RECAPTCHA_CLIENT_V2}
    >
      <div className={props.className}>
        <ListingCard
          withMap
          listing={props.activeListing}
          compliance={props.activeListing && props.activeListing.compliance}
        />
      </div>
    </GlobalProvider>
  );
};

export default InfoWindow;
